import { useSelector } from 'react-redux';
import BotList from '../Bots/BotList';
import WCABotList from '../WCABots/BotList/index';

const BotFlowList = () => {
  const { companyConfigData } = useSelector((state) => state.authenticate);

  return companyConfigData?.wabaPartner === 'skalebot' ? <WCABotList /> : <BotList />;
};

export default BotFlowList;
